@if (isCsgoItem(item)) {
  <div class="weapon-tooltip">
    @if (item.extra.n[0]) {
      <div class="weapon-tooltip__name">
        {{ item.extra.n[0] }}
      </div>
    }

    <div class="weapon-tooltip__header">
      @if (item.extra.n[1]) {
        <div class="weapon-tooltip__type">
          {{ item.extra.n[1] }}
        </div>
      }

      @if (item.extra.st) {
        <div class="weapon-tooltip__stattrak">ST</div>
      }
    </div>

    <div class="weapon-tooltip__footer">
      @if (item.extra.e) {
        <div class="weapon-tooltip__exterior">
          {{ item.extra | itemExterior:item.appId }}
        </div>
      }

      <div class="weapon-tooltip__price"
        [convert]="item.priceUsd"
      ></div>
    </div>
  </div>
} @else {

  <div class="weapon-tooltip">
    <div class="weapon-tooltip__name">
      {{ item.marketName }}
    </div>

    <div class="weapon-tooltip__header">
      <div class="weapon-tooltip__type">
        {{ item.extra | itemExterior:item.appId }}
      </div>
    </div>

    <div class="weapon-tooltip__footer">
      <div class="weapon-tooltip__price"
        [convert]="item.priceUsd"
      ></div>
    </div>
  </div>
}